import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged, map, tap } from 'rxjs';
import { RestService } from './rest.service';

export interface LoggedUser {
  id: string;
  email: string;
  userRole: string;
  firstName: string;
  lastName: string;
  aboutYou: string;
  profilePic: string;
  active: boolean;
  foundationUser: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _loggedUser$ = new BehaviorSubject<LoggedUser | null>(null);
  private _loaded = false;

  readonly loggedUser$: Observable<LoggedUser | null> = this._loggedUser$.asObservable();

  readonly isFoundationUser$: Observable<boolean> = this._loggedUser$.pipe(
    map((user) => user?.foundationUser ?? false),
    distinctUntilChanged()
  );

  constructor(private readonly restService: RestService) {}

  loadLoggedUser(): Observable<any> {
    return this.restService.getLoggedUser().pipe(
      tap((response) => {
        if (response?.data) {
          this._loggedUser$.next(response.data as LoggedUser);
          this._loaded = true;
        }
      })
    );
  }

  get isLoaded(): boolean {
    return this._loaded;
  }

  get snapshot(): LoggedUser | null {
    return this._loggedUser$.getValue();
  }
}
